import $ from "jquery";

export const apiToken =
    "eyJpdiI6ImtrTm0xTSsrTHBkdk5yMEJmcndSWHc9PSIsInZhbHVlIjoiWTJQS3ZRVDI3ai9RQ0RkUUZScEIzVE90V2VRbGFuWjh6dTVqYzRvSjVXRT0iLCJtYWMiOiI0MTM0MWYyMDZiNTMxZmE2YjZhMzgyNGMzOTdiZjkzOWE2OGI3YzIzOGZiMjA2OWE5YjIxYTNmNTMxODFkNWU4IiwidGFnIjoiIn0=";

export const url = "https://accesspass.io";

export const buildInventoryForm = (inventories, title, id) => {
  const inventoryForm = $("#inventoryform");
  // const inventories = response.result.inventories;
  let inventoryHtml = `
  <div class="mb-5">
  Dank voor je aanmelding voor ${title}.<br>
  we willen je vragen de volgende vragen te beantwoorden:
  </div>`;
  inventories.forEach((inventory) => {
    if (inventory.type == "single") {
      let optionHtml = "";

      inventoryHtml += `<div class="inventory-x>`;
      inventoryHtml += `<label class="text-black font-degularText text-lg" for="inventory-${inventory.id}">${inventory.question}</label>`;
      inventory.options.forEach((option) => {
        optionHtml += `<option value="${option}" class="text-lg text-white dark:text-black opacity-60 italic font-degularText
        " ${(inventory.answer !== undefined && inventory.answer === option) && 'selected'}>${option}</option>`;
      });

      inventoryHtml += `
      <select id="inventory-${inventory.id}" name="${inventory.id}">
      <option value="" disabled selected hidden class="text-lg text-white dark:text-black opacity-60 italic font-degularText">Vul hier in</option>
      ${optionHtml}
      </select>
      `;
      inventoryHtml += `</div>`;

      //only text
    } else if (inventory.type == "text") {
      inventoryHtml += `<div class="inventory-x>`;

      inventoryHtml += `
      <label class="text-black font-degularText text-lg"
      for="inventory-${inventory.id}">
      ${inventory.question}
      </label>
      <input type="text"
      id="inventory-${inventory.id}"
      name="${inventory.id}"
      placeholder="Vul hier in"
      class="text-black"
      value="${inventory.answer !== undefined && inventory.answer !== null ? inventory.answer : ''}"
      />`;

      inventoryHtml += `</div>`;

      //multiple checkboxes
    } else if (inventory.type == "multiple") {
      inventoryHtml += `<div class="inventory-x>`;
      let multipleHtml = "";
      inventory.options.forEach((option, key) => {
        let isChecked = false;

        if (inventory.answer !== undefined && inventory.answer !== null) {
          const optionsString = inventory.answer;
          const optionToCheck = option;
          isChecked = optionsString.split(',').includes(optionToCheck);
        }
        multipleHtml += `<div><input name="${inventory.id}[]" id="inventory-${inventory.id}-${key}" type="checkbox" value="${option}" ${isChecked ? 'checked' : ''}  /><label for="inventory-${inventory.id}-${key}" class="ml-2">${option}</label></div>`;
      });
      inventoryHtml += `
      <div class="text-black font-degularText text-lg"
      for="inventory-${inventory.id}">
      ${inventory.question}
      </div>`;

      inventoryHtml += multipleHtml;
      inventoryHtml += `</div>`;
      inventoryHtml += `<div class="mb-3"></div>`;
    }
  });
  inventoryHtml += `
  <div class="mb-3">
  Heb je alle vragen beantwoord? Druk dan op verzenden om je registratie definitief te maken.
  </div>
  <input id="eventid" hidden value="${id}" />
  <div class="flex">
    <button type="button" class="inventorySubmit gap-3 align-bottom pil-btn-black-modal w-full md:w-auto mt-4 pt-2 pb-1 px-5 rounded-full border text-white bg-black border-whiterelative flex items-center justify-center cursor-pointer hover:bg-white hover:text-black hover:border-black">
      <span class="pb-1 text-lg">versturen</span>
    </button>
    <div id="loader-reset-password" class="ml-5 mt-5 loader"></div>
  </div>
  `;

  inventoryForm.html(inventoryHtml);

}


export const inventorySubmit = () => {
  const inventorySubmit = document.querySelector(".inventorySubmit");
  inventorySubmit.addEventListener("click", function (e) {
    console.log("xxx submit inventory clicked");
    e.preventDefault();
    const form = $("#inventoryform");
    let inventories = [];
    const selectElements = document.querySelectorAll(
      'select[id^="inventory-"]'
    );
    // Loop through each select element
    selectElements.forEach((selectElement) => {
      // Get the selected value of each select element
      const selectedValue = selectElement.value;
      const selectedId = selectElement.name;
      // console.log("xxx Selected value:", selectedValue);
      inventories.push({ id: parseInt(selectedId), answer: selectedValue });
      // Perform actions with selectedValue as needed
    });

    const textElements = document.querySelectorAll(
      'input[type="text"][id^="inventory-"]'
    );

    textElements.forEach((textElement) => {
      // Get the selected value of each select element
      const textValue = textElement.value;
      const textId = textElement.name;
      // console.log("xxx text value:", textValue);
      inventories.push({ id: parseInt(textId), answer: textValue });
    });

    const checkboxElements = document.querySelectorAll(
      'input[type="checkbox"][name$="[]"]'
    );
    const idAnswers = {};
    // console.log('xxx', checkboxElements)
    checkboxElements.forEach((checkbox) => {
      const id = checkbox.getAttribute("name").replace("[]", ""); // Extract the ID from the name
      const isChecked = checkbox.checked;
      const value = checkbox.value;

      if (isChecked) {
        // If the checkbox is checked, add its value to the corresponding ID array
        if (!idAnswers[id]) {
          idAnswers[id] = []; // Initialize the array if it doesn't exist
        }
        idAnswers[id].push(value); // Add the value to the array
      }
    });

    const transformedArray = Object.entries(idAnswers).map(
      ([id, answer]) => ({
        id: parseInt(id),
        answer: answer,
      })
    );
    inventories.push(...transformedArray);

    const eventid = document.querySelector("#eventid").value;
    const data = {
      event_id: parseInt(eventid), // Assuming event_id is a number
      inventories: inventories,
    };

    // console.log("xxx data", data);

    const userToken = localStorage.getItem("login-token");
    var settings = {
      url: url + "/api/event/inventory",
      method: "POST",
      timeout: 0,
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Api-Token": apiToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
    };
    $.ajax(settings).done(function (response) {
      console.log(response);
      $("#inventoryform").hide();
      $("#inventorysubmitsuccessful").show();
    });
  });
}
